<template>
  <!-- Яндекс.Музыка: жёлтый круг с красным «плеем» (составной, поэтому отдельная ветка) -->
  <svg v-if="normalized === 'yandex'" :width="size" :height="size" viewBox="0 0 24 24" class="align-middle">
    <circle cx="12" cy="12" r="12" fill="#FFCC00"/>
    <path d="M9 6.8v10.4l8.6-5.2z" fill="#FF0000"/>
  </svg>
  <svg v-else-if="icon" :width="size" :height="size" viewBox="0 0 24 24" :fill="color || icon.color" class="align-middle">
    <path :d="icon.path"/>
  </svg>
</template>

<script>
// Логотипы (path в viewBox 24×24) — из набора simple-icons
const ICONS = {
  spotify: {
    color: '#1DB954',
    path: 'M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z',
  },
  lastfm: {
    color: '#D51007',
    path: 'M10.584 17.21l-.88-2.392s-1.43 1.594-3.573 1.594c-1.897 0-3.244-1.649-3.244-4.288 0-3.382 1.704-4.591 3.381-4.591 2.42 0 3.189 1.567 3.849 3.574l.88 2.749c.88 2.666 2.529 4.81 7.285 4.81 3.409 0 5.718-1.044 5.718-3.793 0-2.227-1.265-3.381-3.63-3.93l-1.758-.385c-1.21-.275-1.567-.77-1.567-1.594 0-.935.742-1.484 1.952-1.484 1.32 0 2.034.495 2.144 1.677l2.749-.33c-.22-2.474-1.924-3.492-4.729-3.492-2.474 0-4.893.935-4.893 3.931 0 1.87.907 3.052 3.189 3.601l1.87.44c1.402.33 1.869.907 1.869 1.704 0 1.017-.99 1.43-2.86 1.43-2.776 0-3.93-1.457-4.59-3.464l-.907-2.75c-1.155-3.573-2.997-4.893-6.653-4.893C2.144 5.333 0 7.89 0 12.233c0 4.18 2.144 6.434 5.993 6.434 3.106 0 4.591-1.457 4.591-1.457z',
  },
}

// Источники групп «Дополнительных треков» → бренд
const SOURCE_MAP = {
  spotify_top: 'spotify',
  spotify_search: 'spotify',
  spotify: 'spotify',
  lastfm: 'lastfm',
  yandex: 'yandex',
}

export default {
  name: 'SourceIcon',
  props: {
    source: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    // Заливка вместо фирменной — например, белый логотип на фирменном бейдже
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    normalized() {
      return SOURCE_MAP[this.source] || null
    },
    icon() {
      return ICONS[this.normalized] || null
    },
  },
}
</script>
